import React from 'react'
import ServiceSection from '../../Components/mumbai/ServiceSection';
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider';
import MaximizeModal from '../../Components/mumbai/MaximizeModal';
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection';
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection';
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper';
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection';
import LocationForm from '../../Components/mumbai/LocationForm';
import WhyChoose from '../../Components/mumbai/WhyChoose';
import EngagementModels from '../../Components/hire/EngagementModels';
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm';

const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "Mobikode's dedicated team in Delhi delivers reliable ServiceNow support, proactive guidance, and timely solutions to keep your business running smoothly and growing confidently. ",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise ",
        description: "At Mobikode, we deliver tailored digital solutions in Delhi, helping healthcare, finance, education, retail, logistics, and businesses innovate confidently together.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "Every business in Delhi has unique goals. Mobikode delivers tailored digital solutions that simplify operations, boost efficiency, and support sustainable, long-term business growth.",
        image: "/assets/mumbai/img2.png"
    },

];

const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "At Mobikode, we help businesses in Delhi simplify operations, enhance customer experiences, and achieve sustainable growth with secure, reliable, innovative technology solutions.",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "At Mobikode, we help Delhi businesses grow with reliable digital solutions that enhance customer experiences, streamline operations, and deliver measurable, long-term success.",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "Helping Delhi businesses simplify operations, enhance customer experiences, automate workflows, and achieve sustainable growth with secure, innovative ServiceNow solutions.",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "At Mobikode, we help Delhi businesses simplify operations, boost productivity, embrace smart technology, and build efficient processes for sustainable growth.",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "At Mobikode Delhi, we empower retail brands with smart digital solutions that enhance customer experiences, simplify operations, and accelerate sustainable growth.",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "At Mobikode, we help Healthcare and Life Sciences organizations across Delhi leverage technology to enhance patient care, streamline operations, and deliver connected digital experiences that improve healthcare outcomes.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "Mobikode empowers media and communication businesses in Delhi with innovative digital solutions that enhance audience engagement, streamline operations, strengthen brand presence, and accelerate sustainable business growth.",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "At Mobikode, we help logistics and transportation businesses in Delhi streamline operations, optimize deliveries, improve customer experiences, and achieve sustainable growth with reliable digital solutions.",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "At Mobikode, we help businesses across Delhi transform ideas into impactful digital solutions through innovative technology, expert engineering, and scalable products that drive sustainable growth.",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "At Mobikode, we empower non-profit organizations in Delhi with innovative technology that simplifies operations, strengthens community engagement, expands outreach, and helps maximize lasting social impact.",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "At Mobikode, we help businesses across Delhi simplify operations, adopt smarter technologies, automate workflows, and deliver seamless customer experiences with reliable, tailored digital solutions.",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "At Mobikode, we help Delhi’s real estate businesses simplify operations, enhance customer experiences, and connect builders, agents, and buyers through innovative digital solutions.",
        image: "/assets/mumbai/item12.png"
    },

];

function Delhi() {
    return (
        <div>
            <Helmet>
                <title>
                    ServiceNow Consulting in Delhi | ITSM & Enterprise Automation | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode offers ServiceNow consulting in Delhi to streamline IT service management, automate enterprise workflows, improve operational visibility, and support smarter digital transformation."
                />

                <meta
                    name="keywords"
                    content="ServiceNow Consulting Delhi, ServiceNow Consultant Delhi, ServiceNow ITSM Delhi, ServiceNow Enterprise Automation Delhi, ServiceNow Workflow Automation Delhi, ServiceNow IT Operations Delhi, ServiceNow Implementation Delhi, ServiceNow Integration Delhi, ServiceNow Managed Services Delhi, ServiceNow Digital Transformation Delhi"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-delhi"
                />

                <meta
                    property="og:title"
                    content="ServiceNow Consulting in Delhi | ITSM & Enterprise Automation | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Modernize IT operations with Mobikode's ServiceNow consulting services in Delhi. Optimize ITSM, automate workflows, integrate enterprise systems, and improve service management across your organization."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-delhi"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/delhi/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="ServiceNow Consulting in Delhi | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Explore ServiceNow solutions in Delhi for ITSM, enterprise workflow automation, IT operations, system integration, and digital transformation with Mobikode."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/delhi/bg1.png"
                />
            </Helmet>
            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in Delhi" description="Partner with Mobikode’s ServiceNow experts in Delhi to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent digital transformation. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/delhi.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />
            {/* <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/mumbai/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Leverage ServiceNow Consulting in Delhi
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Partner with Mobikode’s ServiceNow experts in Delhi to streamline operations, boost productivity, automate workflows, and enable scalable business growth through smart digital solutions.
                        </p>
                    </div>
                </div>
            </section> */}
            {/* <ServiceSection image={"/assets/mumbai/delhi.png"}
                text={"At Mobikode, we help businesses in Delhi unlock the full potential of ServiceNow with customized consulting solutions designed around their unique needs. From implementation and automation to integrations and ongoing support, our experts simplify workflows, improve productivity, and deliver scalable solutions that help organizations grow, adapt, and embrace digital transformation with confidence."}
                title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"}
                title="ServiceNow Consulting Services"
                text="At Mobikode, we help businesses across Delhi maximize ServiceNow with tailored solutions, intelligent automation, and expert consulting that simplify operations, boost productivity, and accelerate digital transformation." />
            <HireDeveloper /> */}
        </div>
    )
}

export default Delhi
